// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__2rPgy","content":"Main_content__3ynzq","ContentBox-questions":"Main_ContentBox-questions__3hHpK","ContentBox-profile":"Main_ContentBox-profile__21Rql"};